<template>
    <div class="zbxx">

        <div class="tab-container">
            <div v-for="(item, key) in tabList" :key="key" @click="handleTab(item.id)"
                :class="activeTab == item.id ? 'tab-content tab-item-active' : 'tab-content tab-item'">
                {{ item.label }}
            </div>
        </div>
        <div class="header-container">
            <div class="nav-wrapper">
                <div v-for="(item, key) in navList" :key="key" @click="handleNav(item.id)"
                    :class="activeNav == item.id ? 'nav-item-active' : 'nav-item'">
                    {{ item.label }}
                    <div v-if="activeNav == item.id" class="nav-line-wrapper">
                        <div class="nav-line"></div>
                    </div>
                </div>
                <div style="clear:both;"></div>
            </div>
            <div class="search-container">
                <div style="width: 300px;">已为您找到 <span style="color: rgba(255, 139, 78, 1);"> {{ totalRecords }}</span> 个内容
                </div>
                <div class="month-wrapper">
                    <el-date-picker v-model="searchMonth" type="daterange" range-separator="至" start-placeholder="开始日期"
                        end-placeholder="结束日期" @change="changeMonth">
                    </el-date-picker>
                    <div class="month-icon-wrapper">
                        <i class="el-icon-caret-bottom month-icon"></i>
                    </div>
                </div>
                <div class="page-mode-input-wrapper">
                    <div class="page-mode-input">
                        <el-input v-model="searchVal" placeholder=" 输入直播名称搜索"></el-input>
                    </div>
                    <div class="input-btn" @click="handleSearch">
                        <i class="el-icon-search input-btn-icon"></i>
                        <span class="input-btn-label">搜索</span>
                    </div>
                </div>

            </div>
        </div>

        <!-- <div v-if="tableData.length > 0" class="table-container">
            <div v-for="(item, key) in tableData" :key="key" class="table-item-wrapper">
                <div class="table-img-wrapper">
                    <img :src="item.coverUrl" alt="" class="table-img">
                </div>
                <div class="table-content-wrapper">
                    <div class="table-content">
                        <div class="table-title-wrapper">
                            <div v-if="item.liveStatus == 1" class="table-status">
                                <div class="table-status-img-wrapper">
                                    <img src="@/assets/img/shape.png" alt="" class="table-status-img">
                                </div>
                                <img src="@/assets/img/live.png" alt="" class="table-status-icon">
                                直播中
                            </div>
                            <div class="table-title">
                                {{ item.title }}
                            </div>
                        </div>
                        <div class="table-brief-wrapper">
                            <div v-if="item.courseCategory == 1" class="table-course-btn">
                                <div class="table-brief-img-wrapper">
                                    <img src="@/assets/img/shape3.png" alt="" class="table-brief-img">
                                </div>
                                <div class="table-brief-title">会员公开课</div>
                            </div>
                            <div class="table-brief">
                                <div class="table-brief-item">讲师：{{ item.teacherName }}</div>
                                <div class="table-brief-item">直播时间：{{ item.startTime }}</div>
                            </div>
                        </div>
                    </div>
                    <div v-if="item.courseType == 2" class="table-btn-wrapper">
                        <div class="table-btn" @click="viewLive(item)">观看</div>
                    </div>
                    <div v-else-if="item.appointmentStatus == 2" class="table-btn-wrapper">
                        <div class="table-btn" @click="bookLive(item)">预约</div>
                    </div>
                    <div v-else class="table-btn-wrapper">
                        <div class="table-btn" @click="viewLive(item)">
                            <span v-if="item.liveStatus == 0">未开始</span>
                            <span v-if="item.liveStatus == 1">进入直播</span>
                            <span v-if="item.liveStatus == 2">回放生成中</span>
                            <span v-if="item.liveStatus == 3">查看回放</span>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <div v-if="tableData.length > 0" class="table-aa">
            <div class="table-container-bx table-container-bx1">
                <div v-for="(item, key) in tableData" :key="key" class="table-item-wrapper">
                    <div class="table-item-wrapper-img">
                        <img class="img1" :src="item.coverUrl" alt="">
                        <img v-if="item.liveStatus == 1" class="zbtype" src="@/assets/img/zbz1.png" alt="">
                        <img v-else-if="item.liveStatus == 3 || item.liveStatus == 2" class="zbtype"
                            src="@/assets/img/zbhf.png" alt="">

                        <img v-else-if="item.liveStatus == 0" class="zbtype" src="@/assets/img/zbyg.png" alt="">
                    </div>
                    <div class="table-item-wrapper-name"> {{ item.title }}</div>
                    <div class="table-item-wrapper-date">{{ item.startTime }}</div>
                    <div class="table-item-wrapper-ls">讲师：{{ item.teacherName }}</div>
                    <div class="table-item-wrapper-jd" v-if="item.liveStatus == 3">
                        <span v-if="item.liveStatus == 3 && item.studyProgress >= 0">已观看{{ item.studyProgress }}%</span>
                        <span v-else>未观看回放 </span>
                    </div>
                    <div class="table-item-wrapper-jd" v-else></div>
                    <!-- <div v-if="item.courseType == 2" class="table-btn-wrapper">
                    <div class="table-btn" @click="viewLive(item)">查看直播</div>
                </div>
                <div v-else-if="item.appointmentStatus == 2" class="table-btn-wrapper">
                    <div class="table-btn" @click="bookLive(item)">预约</div>
                </div> -->
                    <div class="table-btn-wrapper">
                        <div class="table-btn" @click="viewLive(item)">
                            <span v-if="item.liveStatus == 0">查看直播</span>
                            <span v-if="item.liveStatus == 1">查看直播</span>
                            <span v-if="item.liveStatus == 2">回放生成中</span>
                            <span v-if="item.liveStatus == 3">查看回放</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="view-more-btn" v-if="tableData.length > 0 && currentPage < totalPages" @click="viewMore">查看更多
            </div>

        </div>
        <div v-else class="table-container">
            <div class="table-nodata-wrapper">
                <div class="zwsj">
                    <img style="width: 160px;" src="@/assets/img/nodata.png" alt="">
                    <div style="width: 180px;text-align: center;margin-top: 20px;font-size: 17px;color: #999999">
                        暂无数据 ！
                    </div>
                </div>
            </div>
        </div>


        <el-dialog title="" :show-close="true" width="542px" :visible.sync="tipsDialog" class="team-manage-container">
            <div class="dialog-header">
                <div>温馨提示</div>
            </div>
            <div class="dialog-content">
                <div class="dialog-info">
                    课程已预订成功！
                </div>
            </div>
        </el-dialog>
        <el-dialog title="" :show-close="true" width="542px" :visible.sync="bookComfirm" class="team-manage-container">
            <div class="dialog-header">
                <div>温馨提示</div>
            </div>
            <div class="dialog-content">
                <div class="dialog-info">
                    <div>预约精品课程需要消耗直播课次，</div>
                    <div>当前剩余{{ bookTimes }}次，确认预约？</div>
                </div>
                <div class="dialog-btn-wrapper">
                    <el-button @click="cancelBook">取消</el-button>
                    <el-button type="primary" @click="dealBook">确定</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="" :show-close="true" width="542px" :visible.sync="bookFiled" class="team-manage-container">
            <div class="dialog-header">
                <div>温馨提示</div>
            </div>
            <div class="dialog-content">
                <div class="dialog-info">
                    <div>直播课次不足，请联系课程顾问！</div>
                </div>
                <div class="dialog-btn-center">
                    <el-button @click="handleBookFiled">知道了</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    hxtliveList,
    liveCourseList,
    appointmentCourseTimes,
    appointmentCourse
} from '@/api/index.js';
export default {
    name: '',
    components: {

    },
    data() {
        return {
            totalRecords: 0,
            dept: '',
            token: '',
            searchVal: '',
            searchMonth: [],
            tabList: [

                {
                    id: 1,
                    label: '普通直播'
                },
                {
                    id: 2,
                    label: '线上公开课'
                }
            ],
            activeTab: localStorage.getItem('zbactiveTab') ? localStorage.getItem('zbactiveTab') : 1,
            navList: [
                // {
                //     id: 0,
                //     label: '全部'
                // },
                {
                    id: 1,
                    label: '直播预告'
                },
                {
                    id: 2,
                    label: '直播回放'
                },

            ],
            activeNav: localStorage.getItem('zbactiveNav') ? localStorage.getItem('zbactiveNav') : 1,
            tableData: [],
            tipsDialog: false,
            currentPage: 1,
            totalPages: 1,
            startTime: '',
            endTime: '',
            bookComfirm: false,
            bookTimes: 0,
            bookFiled: false,
            bookRow: {}
        }
    },
    mounted() {
        this.dept = window.localStorage.getItem('dept');
        this.token = window.localStorage.getItem('token');
        // this.dept = this.$route.params.dept;
        // this.token = this.$route.params.token;
        this.getTableData();
    },
    methods: {
        //改版前
        // getTableData() {
        //     liveCourseList({
        //         "appointmentStatus": this.activeNav,
        //         "category": this.activeTab,
        //         "startTime": this.startTime,
        //         "endTime": this.endTime,
        //         "deptId": this.dept,
        //         "keyword": this.searchVal,
        //         "pageNum": this.currentPage,
        //         "pageSize": 10,
        //         "userId": 0
        //     }, {
        //         Authorization: this.token,
        //         DeptId: this.dept
        //     }).then(res => {
        //         if (res.code == 200) {
        //             var data = res.data.list;
        //             var tableArr = this.tableData;
        //             this.tableData = tableArr.concat(data);
        //             this.totalPages = res.data.totalPages;
        //         }
        //         return;
        //     }).catch(err => {
        //        // console.log(err);
        //     });
        // },
        //改版前后
        getTableData() {
            hxtliveList({
                "type": 0,
                "appointmentStatus": 0, //0/(不传)=默认全部，1=已预约
                "category": this.activeTab,//前端直播分类 ：0/(不传)为查询全部  ，1=课程直播筛选   ，2=线上公开课直播筛选
                "startTime": this.startTime,
                "endTime": this.endTime,
                // "deptId": this.dept,
                "keyword": this.searchVal,
                "pageNum": this.currentPage,
                "pageSize": 20,
                // "userId": 0,
                "liveStatus": this.activeNav,//直播状态：0/(不传)=默认全部，1=直播，2=回放
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    console.log("**************11111111", res)
                    var data = res.data.list;
                    var tableArr = this.tableData;
                    this.tableData = tableArr.concat(data);
                    this.totalPages = res.data.totalPages;
                    this.totalRecords = res.data.totalRecords;
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        handleTab(target) {
            this.activeTab = target;
            localStorage.setItem('zbactiveTab', target)
            this.currentPage = 1;
            this.tableData = [];
            this.getTableData();
        },
        handleNav(target) {
            localStorage.setItem('zbactiveNav', target)
            this.activeNav = target;
            this.currentPage = 1;
            this.tableData = [];
            this.getTableData();
        },
        handleSearch() {
            this.currentPage = 1;
            this.tableData = [];
            this.getTableData();
        },
        changeMonth() {

            var searchDateArr = this.searchMonth;
            if (searchDateArr) {
                this.startTime = this.getFormateDate(searchDateArr[0]);
                this.endTime = this.getFormateDate(searchDateArr[1]);
                this.currentPage = 1;
                this.tableData = [];
            } else {
                this.startTime = ''
                this.endTime = ''
                this.currentPage = 1;
                this.tableData = [];
            }

            this.getTableData();
        },
        getFormateDate(params) {
            var date = new Date();
            if (params) {
                date = new Date(params);
            }
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var day = date.getDate();
            if (month < 10) {
                month = '0' + month;
            }
            if (day < 10) {
                day = '0' + day;
            }
            return `${year}-${month}-${day}`;
        },
        viewMore() {
            var currentPage = this.currentPage;
            if (currentPage < this.totalPages) {
                this.currentPage = currentPage + 1;
                this.getTableData();
            } else {
                this.$message({
                    message: '没有更多了',
                    type: 'warning'
                });
            }
        },
        bookLive(row) {
            this.bookRow = row;
            appointmentCourseTimes(row.infoId, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(async (res) => {
                if (res.code == 200) {
                    var times = res.data.times;
                    if (times > 0) {
                        this.bookTimes = times;
                        this.bookComfirm = true;
                    } else if (times == 0) {
                        this.bookFiled = true;
                    } else {
                        //免费课
                        var _this = this;
                        await this.requestBook(function () {
                            _this.tipsDialog = true;
                        });
                    }
                    this.currentPage = 1;
                    this.tableData = [];
                    this.getTableData();
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        /**取消预约 */
        cancelBook() {
            this.bookComfirm = false;
        },
        /**确定预约 */
        dealBook() {
            var _this = this;
            this.requestBook(function () {
                _this.bookComfirm = false;
                _this.getTableData();
            });
        },
        async requestBook(callback) {
            var id = this.bookRow.infoId;
            await appointmentCourse(id, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    callback();
                } else {
                    this.$message.error(res.msg);
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        handleBookFiled() {
            this.bookFiled = false;
        },
        viewLive(row) {

            this.$router.push({ path: `/courseDetail/live-learn/${row.infoId}/${this.dept}/1`, query: { courseType: row.courseType } });


        }
    }
}
</script>

<style scoped>
.tab-container {
    width: 1220px;
    margin: 0 auto;
    display: flex;
    margin-top: 15px;
}

.zbxx {
    width: 100%;

    margin-top: 20px;
    overflow: hidden;
}

.tab-content {
    width: 102px;
    height: 32px;
    border-radius: 16px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    cursor: pointer;
    margin-right: 30px;
}

.tab-item {
    color: #333333;
}

.tab-item-active {
    background: linear-gradient(90deg, #5580F5 0%, #72A3F5 100%);
    color: #FFFFFF;
}

.header-container {
    width: 1200px;
    margin: 0 auto;

    margin-top: 16px;
}

.nav-wrapper {
    width: 440px;
}

.nav-item-active {
    width: 102px;
    text-align: center;
    float: left;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
    height: 36px;
    line-height: 25px;
    margin-right: 30px;
    position: relative;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    cursor: pointer;
}

.nav-item {
    width: 102px;
    text-align: center;
    float: left;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #9B9FAA;
    height: 36px;
    line-height: 25px;
    margin-right: 30px;
    position: relative;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.nav-item:hover {
    cursor: pointer;
    color: #000000;
}

.nav-line-wrapper {
    width: 100%;
    bottom: 0px;
    left: 0px;
    position: absolute;
    display: flex;
    justify-content: center;
    margin-top: 6px;
}

.nav-line {
    width: 22px;
    height: 6px;
    background: #4F79ED;
    border-radius: 3px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.search-container {
    margin-top: 20px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-bottom: 10px;
}

.table-container {
    margin-top: 20px;
    height: 620px;
}



.page-mode-input-wrapper {
    display: flex;
    width: 400px;
    position: relative;
    top: -5px;
}

.page-mode-input>>>.el-input__inner {
    width: 300px !important;
    height: 38px !important;
    border-radius: 6px 0px 0px 6px !important;
    border: 1px solid #6D94FF !important;
    border-right: 0px !important;
}

.input-btn {
    width: 75px;
    height: 38px;
    background: #6D94FF;
    border-radius: 0px 6px 6px 0px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.input-btn:hover {
    cursor: pointer;
    opacity: 0.8;
}

.input-btn-icon {
    font-size: 13px;
}

.input-btn-label {
    margin-left: 5px;
}

.month-wrapper {
    margin-left: 20px;
    position: relative;
    top: -5px;
}

.month-wrapper>>>.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    cursor: pointer !important;
    border: 1px solid #ccc;
}

.month-wrapper>>>.el-input__inner {
    /* border: 0px !important; */
    font-size: 14px !important;
    font-family: PingFangSC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #333333 !important;
    /* padding: 0px !important; */
    cursor: pointer !important;
}

.month-wrapper>>>.el-input__prefix {
    display: none !important;
}

.month-icon-wrapper {
    position: absolute;
    right: 0px;
    top: 11px;
}

.month-icon {
    color: #4F79ED;
}

/* .table-item-wrapper {
    display: flex;
    justify-content: space-between;
    padding-top: 32px;
} */

.table-img-wrapper {
    width: 148px;
}

.table-content-wrapper {
    flex: 1;
    height: 120px;
    display: flex;
    justify-content: space-between;
    margin-left: 50px;
    border-bottom: solid #F0F0F0 1px;
}

.table-img {
    width: 148px;
    height: 92px;
    border-radius: 5px;
}

.table-btn-wrapper {
    margin-top: 17px;
}

.table-btn {
    margin: 0 auto;
    width: 248px;
    height: 32px;
    border-radius: 2px;
    line-height: 32px;
    background: #F7F7F7;

    text-align: center;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3E63EE;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.table-btn:hover {
    cursor: pointer;
    background: #3E63EE;
    color: #fff;
}

.table-title-wrapper {
    display: flex;
}

.table-title {
    width: 396px;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
}

.table-brief-wrapper {
    margin-top: 20px;
    display: flex;
}

.table-status {
    width: 90px;
    height: 26px;
    position: relative;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #F6986D;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 30px;
}

.table-status-no {
    width: 90px;
    height: 26px;
    position: relative;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #9B9FAA;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 30px;
}

.table-status-img-wrapper {
    position: absolute;
    left: 0px;
    top: 0px;
}

.table-status-img {
    width: 90px;
    height: 26px;
}

.table-status-icon {
    width: 14px;
    height: 12px;
    margin-right: 3px;
}

.table-course-btn {
    width: 108px;
    height: 28px;
    position: relative;
    margin-right: 34px;
}

.table-brief-img {
    width: 108px;
    height: 28px;
}

.table-brief-title {
    width: 108px;
    height: 28px;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    position: absolute;
    left: 0px;
    top: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.table-brief {
    height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.table-brief-item {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #9B9FAA;
    margin-right: 34px;
}

.view-more-btn {
    width: 122px;
    height: 34px;
    border-radius: 20px;
    border: 1px solid #F69264;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #F69568;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    margin-top: 50px;
    margin-bottom: 20px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    margin-bottom: 40px;
}

.view-more-btn:hover {
    cursor: pointer;
    background: #F69264;
    color: #fff;
}

.team-manage-container>>>.el-dialog__body {
    padding: 0px !important;
}

.team-manage-container>>>.el-dialog__header {
    padding: 0px !important;
}

.dialog-header {
    width: 100%;
    height: 59px;
    background: #F8FAFF;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
}

.dialog-content {
    padding: 46px 77px 60px 77px;
}

.dialog-info {
    text-align: center;
}

.dialog-btn-wrapper {
    display: flex;
    justify-content: space-between;
    margin-top: 50px;
}

.dialog-btn-center {
    display: flex;
    justify-content: center;
    margin-top: 50px;
}

.dialog-content>>>.el-button {
    width: 148px !important;
    height: 40px !important;
    line-height: 40px !important;
    border-radius: 6px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    font-size: 18px !important;
    font-family: PingFangSC-Regular, PingFang SC !important;
}

.dialog-content>>>.el-button--primary {
    background: linear-gradient(90deg, #5580F5 0%, #72A3F5 100%) !important;
}

.dialog-content>>>.el-button--default {
    border: 1px solid #4F79ED;
    color: #4F79ED !important;
}

.table-nodata-wrapper {
    min-height: 600px;
    display: flex;

}

.zwsj {
    width: 160px;
    height: 200px;
    margin: 150px auto;
}

.nodata-label {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    text-align: center;
    margin-top: 20px;
}

.table-aa {
    overflow: hidden;
    margin-top: 10px;
    width: 100%;
    height: 630px;
    background: rgba(250, 250, 250, 1);
    overflow-y: auto;
}

.table-container-bx {

    display: flex;
    flex-wrap: wrap;
    background: #FAFAFA;


}

.table-container-bx1 {
    width: 1200px;
    margin: 10px auto;

}

.table-container-bx>.table-item-wrapper {
    margin-left: 5px;
    margin-right: 5px;
    margin-bottom: 10px;
    width: 280px;
    height: 347px;
    background: #FFFFFF;
    box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
    border-radius: 8px;
    border: 1px solid #F0F0F3;
}

.table-item-wrapper-img {
    width: 100%;
    height: 158px;
    border-radius: 8px 8px 0px 0px;
    overflow: hidden;
    margin: 0;
    padding: 0;
    position: relative;
}

.table-item-wrapper-img>.img1 {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;

}

.zbtype {
    position: absolute;
    top: 0;
    left: 10px;
    z-index: 1000;
    width: 76px;
    height: 20px;
}

.table-item-wrapper-name {
    margin-top: 5px;
    width: 248px;
    height: 44px;
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #333333;

    margin: 10px auto;

    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    /* 显示两行内容 */
    overflow: hidden;
}

.table-item-wrapper-date {
    width: 248px;
    margin: 10px auto;
    height: 15px;
    font-size: 12px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #9B9FAA;
    line-height: 15px;

}

.table-item-wrapper-ls {
    width: 248px;
    margin: 10px auto;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 20px;
}

.table-item-wrapper-jd {
    width: 248px;
    margin: 0 auto;
    height: 10px;
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 10px;
}
</style>


